import { Store, createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { logger } from 'app/middleware';
import { RootState, rootReducer } from 'app/reducers';

// Wrap up our loggina and hot-reloading middleware
export function configureStore(initialState?: RootState): Store<RootState> {
	let middleware = applyMiddleware(logger);

	if (process.env.NODE_ENV !== 'production') {
		middleware = composeWithDevTools(middleware);
	}

	const store = createStore(rootReducer as any, initialState as any, middleware) as Store<
		RootState
	>;

	// Vite handles HMR automatically, no need for manual module replacement

	return store;
}
